import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider flex items-center gap-1" }
const _hoisted_2 = { class: "text-sm text-white break-words font-medium" }




export default /*@__PURE__*/_defineComponent({
  __name: 'MobileDataLabel',
  props: {
    label: {},
    className: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col gap-0.5", _ctx.className])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      _renderSlot(_ctx.$slots, "label-icon")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})